module.exports = __webpack_public_path__ + "static/media/buy_report_user_2.7eb75e6b.png";